/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';
import cx from 'classnames';

import { detectionIsOn } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

export function DetectionsCell<D extends object>({
    cell,
}: Props<D>): JSX.Element | string {
    const detection_status = cell?.value ?? null;
    const detectionIsEnabled = detectionIsOn(detection_status);

    return (
        <div
            className={cx('text-center font-semibold', {
                'text-secondary-500': detectionIsEnabled,
            })}
        >
            {detectionIsEnabled && <>On</>}
            {!detectionIsEnabled && <>Off</>}
        </div>
    );
}
